module.exports = __webpack_public_path__ + "static/media/sound3.07917614.mp3";